import { render, staticRenderFns } from "./doggy-packs-list-page.vue?vue&type=template&id=c060e180&scoped=true&lang=pug"
import script from "./doggy-packs-list-page.js?vue&type=script&lang=js&external"
export * from "./doggy-packs-list-page.js?vue&type=script&lang=js&external"
import style0 from "./doggy-packs-list-page.vue?vue&type=style&index=0&id=c060e180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c060e180",
  null
  
)

export default component.exports